import { SConstants } from "src/app/SayTS/const/s-constants"


export class Constants extends SConstants {

  public static LANGUAGES = ["cs", "en", "de"]
  public static DEF_LANGUAGE = "en"

  public static LOCATIONS_PATH = "Locations/"
  public static CLIENTS_PATH = "Clients/"



  public static COLS_LOCATIONS = [
    { type: 'text', attr: 'client_name' },
    { type: 'text', attr: 'name' },
    { type: 'text', attr: 'city' },
    { type: 'text', attr: 'street' },
    { type: 'translate', attr: 'type' },
    { type: 'text', attr: 'manager_name' },
  ]
  
  public static TABS_REQUESTS = []
  
  public static TAB_LOCATIONS = {
    refreshUrl: 'locations/list',
    detailId: 'id_location',
    detailUrl: 'locations',
    cols: this.COLS_LOCATIONS,
    mobileSearchAttr: 'name',
    mobileDivs: [
      { type: 'text', attr: 'name', class: 'col-12 fw-bold' },
      { type: 'text', attr: 'client_name', class: 'col-8' },
    ],
  }

}


